import sortBy from 'lodash/sortBy'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'

import type { Collection, Model } from 'modules/core/lib/mobx-rest'

import locations from 'modules/locations/store/collections/locations'
import type Location from 'modules/locations/store/models/Location'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import type Team from 'modules/teams/store/models/Team'

function sortedBy<T extends Model = any>(propName: string, toSort: Collection<T>) {
  return sortBy<T>(toSort.models, (model: T) => model.attributes[propName])
}

const teamOptions = async () => {
  await teams.fetch({ withCachedFetchParams: true })
  // NOTE: we need to fetch memberships to be able to filter by team
  await memberships.fetch({ withCachedFetchParams: true })

  return sortedBy<Team>('name', teams).map((team) => ({
    value: team.attributes.id,
    label: team.attributes.name,
  }))
}

const locationOptions = async () => {
  await locations.fetch({ withCachedFetchParams: true })

  return sortedBy<Location>('name', locations).map((location) => ({
    value: location.attributes.id,
    label: location.attributes.name,
  }))
}

const filterFields: () => Promise<FilterOption[]> = async () => {
  return [
    {
      label: i18n.t('filters.multi_filters.location'),
      value: 'location',
      type: 'single_choice',
      options: await locationOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.team'),
      value: 'team',
      type: 'single_choice',
      options: await teamOptions(),
    },
  ]
}

export default filterFields
